import { useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import Header from "./components/Header";
import Home from "./pages/Home";
import ThankYou from "./pages/thankyou";
import ThankYouRejected from "./pages/thankyou-ineligible";
import { pageViewEvent } from "./services/adobeDataLayer";

function App() {
  //Trigger AA Page View Event
  useEffect(() => {
    pageViewEvent("landing page");
  }, []);
  return (
    <>
      {/* update basename while pushing to UAT/LIVE {UAT: v2/46725/lp/hl/landLoan/main/, live:window.location.pathname } */}
      <Router basename={window.location.pathname}>
        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/thankyou-not-eligible" element={<ThankYouRejected />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
